import { ActionTree } from "vuex";
import { RootStateType } from "@/store";
import {AxiosInstance} from "axios";
import {OwnerState} from "@/store/modules/hcs/owner/model";
import {Owner} from "@/store/modules/hcs/Model";

const actions: ActionTree<OwnerState, RootStateType> = {
  get({ rootGetters, state, commit }, id) {
    const our = rootGetters['hcs/account'].owner;
    if(our?.id === id) {
      return our;
    }

    const found = state.owners.get(id);
    if(found) {
      return found;
    }

    const axios = rootGetters['hcs/client'] as AxiosInstance;
    const promise = axios.get<Owner>(`/assets/owners/${id}`)
      .then(response => {
        commit('setOwner', {ownerId: id, owner: response.data});
        return response.data;
      });
    commit('setOwner', {ownerId: id, owner: promise});
    return promise;
  },
}

export default actions;
